
    import './styles.scoped.css';
    export default {
  "code-editor": "awsui_code-editor_1gl9c_s2lj4_98",
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_s2lj4_342",
  "pane": "awsui_pane_1gl9c_s2lj4_354",
  "pane__close-container": "awsui_pane__close-container_1gl9c_s2lj4_365",
  "pane__list": "awsui_pane__list_1gl9c_s2lj4_370",
  "pane__table": "awsui_pane__table_1gl9c_s2lj4_377",
  "pane__item": "awsui_pane__item_1gl9c_s2lj4_382",
  "pane__cell": "awsui_pane__cell_1gl9c_s2lj4_382",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_s2lj4_396",
  "pane__location": "awsui_pane__location_1gl9c_s2lj4_417",
  "pane__description": "awsui_pane__description_1gl9c_s2lj4_417",
  "focus-lock": "awsui_focus-lock_1gl9c_s2lj4_432",
  "resizable-box": "awsui_resizable-box_1gl9c_s2lj4_455",
  "resizable-box-handle": "awsui_resizable-box-handle_1gl9c_s2lj4_460",
  "editor": "awsui_editor_1gl9c_s2lj4_485",
  "status-bar": "awsui_status-bar_1gl9c_s2lj4_518",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_s2lj4_527",
  "status-bar__left": "awsui_status-bar__left_1gl9c_s2lj4_531",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_s2lj4_538",
  "status-bar__right": "awsui_status-bar__right_1gl9c_s2lj4_542",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_s2lj4_546",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_s2lj4_546",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_s2lj4_551",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_s2lj4_555",
  "tab-button": "awsui_tab-button_1gl9c_s2lj4_561",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_s2lj4_574",
  "tab-button--active": "awsui_tab-button--active_1gl9c_s2lj4_588",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_s2lj4_608",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_s2lj4_638",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_s2lj4_645",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_s2lj4_645",
  "loading-screen": "awsui_loading-screen_1gl9c_s2lj4_649",
  "error-screen": "awsui_error-screen_1gl9c_s2lj4_650"
};
  